import { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { roles } from "../../../../store/roles_skills";
import { assingRoles, getEmployeeRoles } from "../../../../store/employee";

interface Props {
  isShown: boolean;
  toggle: any;
  id: string;
}

const AddRoles = ({ isShown, toggle, id }: Props) => {
  const dispatch = useAppDispatch();
  const { roles } = useAppSelector((store) => store.roles_skills);
  const { status, detailEmployeeRoles } = useAppSelector(
    (store) => store.employee
  );
  const [selec, setSelec] = useState(roles);
  const [select, setSelect] = useState(detailEmployeeRoles);
  let selectable: roles[] = [];

  const handleSelects = (value: string) => {
    let newSelec = selec.filter((selec) => selec.slug !== value);
    let newSelect = select.map((selec: any) => {
      return selec;
    });
    newSelect.push(...selec.filter((selec) => selec.slug === value));

    setSelec(newSelec);
    setSelect(newSelect);
  };

  const handleDeSelects = (value: string) => {
    let newSelect = select.filter((selec) => selec.slug !== value);
    let newSelec = selec.map((selec) => {
      return selec;
    });

    newSelec.push(...select.filter((selec) => selec.slug === value));

    setSelec(newSelec);
    setSelect(newSelect);
  };

  const handleSubmit = () => {
    let send = select.map((selec) => {
      return selec.id_encrypted;
    });
    // console.log(send);
    if (isShown) {
      dispatch(assingRoles({ id_user: id, id_role: send }));
    }
  };

  useEffect(() => {
    if (isShown) {
      selectable = roles.filter((skill) => {
        return !detailEmployeeRoles.find((skills) => {
          return skill.slug === skills.slug;
        });
      });
      setSelec(selectable);
      setSelect(detailEmployeeRoles);
    }
  }, [isShown, detailEmployeeRoles]);

  useEffect(() => {
    if (isShown) {
      dispatch(getEmployeeRoles({ id_encrypted: id }));
    }
  }, [isShown]);

  useEffect(() => {
    if (isShown && status === "assingRoles_success") {
      toggle();
    }
  }, [isShown, status]);

  const loader = (
    <>
      <h1>Loading</h1>
    </>
  );
  if (status === "getEmployeeRoles_loading") {
    return loader;
  }

  return (
    <>
      <div className="c-select-list">
        <span style={{ marginBottom: "10px" }}>Skills List</span>
        <div className="c-select-list__select-container">
          <div className="c-select-list__selectable">
            {/* <input
              type="text"
              autoComplete="off"
              placeholder="Search a skill"
              className="c-select-list__input"
            /> */}
            <ul className="c-select-list__list" id="list-selectable">
              {isShown &&
                selec &&
                selec.map((select) => (
                  <li
                    className="c-list-options__item"
                    onClick={() => handleSelects(select.slug)}
                  >
                    <span>{select.slug}</span>
                  </li>
                ))}
            </ul>
          </div>
          <div className="c-select-list__selection">
            {/* <input
              type="text"
              autoComplete="off"
              placeholder="Search a skill"
              className="c-select-list__input"
            /> */}
            <ul className="c-select-list__list">
              {select &&
                select.map((skill) => (
                  <li
                    className="c-list-options__item"
                    key={skill.id}
                    id={skill.id_encrypted + skill.id + id}
                    onClick={() => handleDeSelects(skill.slug)}
                  >
                    <span>{skill.slug} </span>
                  </li>
                ))}
            </ul>
          </div>
        </div>
        <div className="c-select-list__footer" style={{ marginTop: "20px" }}>
          <button
            type="submit"
            className="c-select-list__button-submit"
            onClick={handleSubmit}
          >
            Save Changes
          </button>
        </div>
      </div>
    </>
  );
};
export default AddRoles;
